export enum InputType {
  Email = 'email',
  Numbers = 'number',
  Phone = 'tel',
  Text = 'text'
}
